module.exports = __webpack_public_path__ + "static/media/30.0dc6a20c.mp3";